import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { BrandContext } from "../../../contexts/BrandContext";
import { AppState } from "../../../redux/reducers";
import { BrandState } from "../../../redux/reducers/brand.reducer";
import { UserState } from "../../../redux/reducers/user.reducer";
import {
  brandSelector,
  userSelector,
} from "../../../redux/selectors/app.selectors";
import ImageWrapper from "../custom-components/image-wrapper/ImageWrapper";
import Utils from "../../../utils/Utils";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { useRouter } from "next/router";
import NextRouteConfig from "../../../../next-routes/NextRouteConfig";

interface NFTHeaderProps { }

const BrandPageHeader: React.FC<NFTHeaderProps> = (props) => {
  const { isMobile } = useBreakpoint();
  const router = useRouter();

  const userState: UserState = useSelector((state: AppState) =>
    userSelector(state)
  );
  const { brand }: BrandState = useSelector((state: AppState) =>
    brandSelector(state)
  );
  const brandValue = React.useContext(BrandContext);
  const isUser = !!userState?.userData;
  const isAdmin = !!userState.adminData;
  const isPublic = !isUser && !isAdmin;

  return (
    <div
      id={"header"}
      style={
        !!brandValue?.brand_banner_url && ((isMobile && isAdmin) || !isMobile)
          ? {
            backgroundImage: `url(${brandValue?.brand_banner_url})`,
            backgroundSize: "100% auto",
            backgroundColor: brandValue?.banner_background_color,
          }
          : {}
      }
      className={`flex bg-no-repeat items-center justify-between nft-header lg:justify-between w-full bg-center sm:h-[7.5rem] rounded-xl md:bg-no-repeat md:bg-center`}
    >
      <div className="flex items-center w-full sm:h-full px-4 lg:px-8  md:bg-none">
        <div
          className={classNames(
            "relative flex items-center justify-end w-full md:justify-end",
            {
              "justify-between": isUser,
            }
          )}
        >
          {isUser ? (
            <div onClick={() => router.push(NextRouteConfig.USER.SETTINGS._root)} role="button" className="no-tap-highlight block border-2 border-white rounded-full shrink-0 md:hidden cursor-pointer">
              <ImageWrapper
                height={60}
                width={60}
                className={` w-16 h-16 sm:w-full transition-all !aspect-square object-cover rounded-full duration-500`}
                url={
                  userState.userData?.profile_pic_url ??
                  "/images/profile.placeholder.png"
                }
              />
            </div>
          ) : null}

          <div className={"flex items-center mt-3 text-white md:hidden"}>
            <span className={`text-center`}>
              <h1
                className={classNames(" text-black w-full", {
                  " text-[28px] font-[28px]": isMobile,
                  "font-semibold text-4xl": !isMobile,
                })}
              >
                {isUser
                  ? Utils.numberWithCommas(userState?.userData?.points ?? 0)
                  : isPublic
                    ? brand?.title
                    : null}
              </h1>
              {isUser ? (
                <h1 className="text-[14px] text-black sm:whitespace-nowrap">
                  {brand?.currency ?? "Points"}
                </h1>
              ) : null}
            </span>
          </div>

          <div className="flex ">
            <img
              className={" sm:h-16 lg:h-20 xl:h-24 2xl:h-28 object-cover " + (isAdmin ? "h-12" : "h-16")}
              src={brandValue?.brand_logo_url}
              alt=""
            />
          </div>
        </div>
      </div>
    </div >
  );
};

export default BrandPageHeader;
